import React, { useState } from 'react';
import { TrashCanOutlined } from '@duxton-web/icons';
import { Button, Modal, Tooltip, Typography } from '@duxton-web/ui';

import { getRolloutTargetName } from '@/features/rollout/utils/rollout-target';
import { RolloutTarget } from '@/lib/PlannerDTOs';

interface DeleteButtonProps {
  rolloutTarget: RolloutTarget;
  rolloutIndex: number;
  disabled: boolean;
  deleteBlock: (index: number) => any;
}

export default function DeleteButton({
  rolloutTarget,
  rolloutIndex,
  disabled,
  deleteBlock,
}: DeleteButtonProps) {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const rolloutTargetName = getRolloutTargetName(rolloutTarget?.constraints);

  if (disabled) return null;

  return (
    <>
      <Tooltip title="Click here to delete the rollout target">
        <Button
          size="small"
          shape="circle"
          type="secondary"
          danger
          onClick={(e) => {
            e.stopPropagation();

            setOpenModal(true);
          }}
          icon={<TrashCanOutlined />}
        />
      </Tooltip>
      <div onClick={(e) => e.stopPropagation()}>
        <Modal
          maskClosable={false}
          centered={true}
          open={openModal}
          title="Delete Rollout"
          cancelText="Cancel"
          cancelButtonProps={{
            size: 'small',
          }}
          okType="danger"
          okText="Delete"
          okButtonProps={{
            size: 'small',
            danger: true,
            type: 'primary',
          }}
          onOk={() => {
            deleteBlock(rolloutIndex);

            setOpenModal(false);
          }}
          onCancel={() => {
            setOpenModal(false);
          }}
        >
          <Typography.Text>
            Are you sure you want to delete{' '}
            <Typography.Text strong>
              &ldquo;{rolloutTargetName}&rdquo;
            </Typography.Text>
          </Typography.Text>
        </Modal>
      </div>
    </>
  );
}
